import type {ReactNode} from 'react';
import React from 'react';
import type {AiChatQuickTipsItemHeaderIconProps} from './ai-chat-quick-tips-item-header-icon.types';
import styles from './ai-chat-quick-tips-item-header-icon.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';

export function AiChatQuickTipsItemHeaderIcon({...props}: AiChatQuickTipsItemHeaderIconProps): ReactNode {
  return (
    <div className={`${styles.container} radius-8 flex-center hover-transition-all`}>
      <Icon className={styles.icon} icon={props.icon} size={IconSize.SIZE_ICON_16} shape={IconShape.SQUARE} type={IconType.FLAT} />
    </div>
  );
}
